export type Comparator = 'eq' | 'gt' | 'gte' | 'lt' | 'lte';

export type ComparatorFunction<RHS, LHS = RHS> = (x: LHS, y: RHS) => boolean;

const asNumeric = (fn: ComparatorFunction<number>) => (x: string, y: string): boolean => fn(parseFloat(x), parseFloat(y));
const asSingleValue = (fn: ComparatorFunction<string, string>) => (x: string[], y: string): boolean => fn(x[0], y);

const comparators: { [K in Comparator]: ComparatorFunction<string, string[]> } = {
  eq: asSingleValue((x, y) => x === y),
  gt: asSingleValue(asNumeric((x, y) => x > y)),
  gte: asSingleValue(asNumeric((x, y) => x >= y)),
  lt: asSingleValue(asNumeric((x, y) => x < y)),
  lte: asSingleValue(asNumeric((x, y) => x <= y)),
};

export const validateAnswer = (comparator: Comparator, lhs: string[], rhs: string): boolean => (
  comparators[comparator](lhs, rhs)
);
